module.exports = __webpack_public_path__ + "img/Bitmap@124x (1).19cb0481.png";